module.exports = __webpack_public_path__ + "static/media/art-sample-3.98aee970.png";